import { Link, useNavigate } from "react-router-dom";

import { Space, Breadcrumb, Card } from "antd";
import { PageHeader } from "@ant-design/pro-layout";

import {
  DeviceProfileDevice,
  DeviceProfileVendor,
  UpdateDeviceProfileDeviceRequest,
} from "@chirpstack/chirpstack-api-grpc-web/api/device_profile_pb";

import DeviceForm from "./DeviceForm";
import deviceProfileStore from "../../stores/DeviceProfileStore";
import { useTitle } from "../helpers";

interface IProps {
  vendor: DeviceProfileVendor;
  device: DeviceProfileDevice;
}

function EditDevice(props: IProps) {
  useTitle(
    "Network Server",
    "Device Profiles",
    "Vendors",
    props.vendor.getName(),
    props.device.getName(),
    "Edit",
  );
  const navigate = useNavigate();

  const onFinish = (device: DeviceProfileDevice) => {
    device.setId(props.device.getId());
    device.setVendorId(props.vendor.getId());
    const req = new UpdateDeviceProfileDeviceRequest();
    req.setDevice(device);

    deviceProfileStore.updateDevice(req, () => {
      navigate(`/device-profiles/vendors/${props.vendor.getId()}/devices/${props.device.getId()}/profiles`);
    });
  };

  return (
    <Space orientation="vertical" style={{ width: "100%" }} size="large">
      <PageHeader
        breadcrumbRender={() => (
          <Breadcrumb
            items={[
              { title: "Network Server" },
              { title: "Device Profiles" },
              { title: <Link to="/device-profiles/vendors">Vendors</Link> },
              {
                title: (
                  <Link to={`/device-profiles/vendors/${props.vendor.getId()}/devices`}>{props.vendor.getName()}</Link>
                ),
              },
              { title: props.device.getName() },
              { title: "Edit" },
            ]}
          />
        )}
        title={`Edit ${props.device.getName()}`}
      />
      <Card>
        <DeviceForm initialValues={props.device} onFinish={onFinish} />
      </Card>
    </Space>
  );
}

export default EditDevice;
